import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import {ProductCourseInfo} from "../../models/product-course-info.model";

@Component({
  selector: 'leap-course-information',
  templateUrl: './course-information.component.html',
  styleUrls: ['./course-information.component.less', '../../styles/tab-content.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CourseInformationComponent {

  @Input() courseInfo: ProductCourseInfo;
  @Input() description: string;
  @Input() outline: string;
  @Input() targetAudience: string;
  @Input() learningObjectives: string;
  @Input() agenda: string;

  constructor() {}
}
